import React from 'react';
import { FadeIn } from './FadeIn';
export function FutureSection() {
  const benefits = [{
    emoji: '📱',
    title: "Tu ouvres l'app avec confiance, pas avec anxiété.",
    desc: 'Tu sais exactement quoi faire.'
  }, {
    emoji: '💬',
    title: 'Tes conversations ne meurent plus.',
    desc: "Tu as les scripts. Il n'a aucune chance de s'ennuyer."
  }, {
    emoji: '🗓️',
    title: 'Tu choisis tes rendez-vous.',
    desc: 'Plus question d\'accepter un "T\'es libre ce soir ?" de dernière minute.'
  }, {
    emoji: '🚫',
    title: 'Tu identifies les imposteurs en 3 messages.',
    desc: 'Fini les mois perdus avec les mauvaises personnes.'
  }, {
    emoji: '👑',
    title: "Tu deviens celle qu'on n'ose pas ghoster.",
    desc: 'Parce que perdre ton attention devient insupportable pour lui.'
  }];
  return <section className="py-16 md:py-32 relative bg-gradient-to-b from-deep-black to-[#110a0c]" data-id="element-128">
      <div className="max-w-4xl mx-auto px-6" data-id="element-129">
        <FadeIn data-id="element-130">
          <h2 className="font-playfair text-3xl md:text-5xl text-center text-cream mb-16 leading-tight" data-id="element-131">
            À quoi ressemblera ta vie dans{' '}
            <span className="text-champagne-gold italic" data-id="element-132">21 jours</span>
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-133">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.15} direction="left" data-id="element-134">
              <div className="flex items-start gap-6 p-6 rounded-2xl bg-deep-black/40 border border-white/5 hover:border-champagne-gold/30 transition-colors duration-300" data-id="element-135">
                <div className="text-3xl mt-1" data-id="element-136">{benefit.emoji}</div>
                <div data-id="element-137">
                  <h3 className="text-lg md:text-xl font-medium text-cream mb-2" data-id="element-138">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-cream font-light text-sm md:text-base" data-id="element-139">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}